module.exports = __webpack_public_path__ + "img/finances.5d41034e.webp";